import { useEffect, useState } from "react"
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import Form from "../../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import { AREA_API } from "../../../../../Utilities/APIs/APIs"

function UpdateArea({targetID, triggerFetch, setShowUpdateForm}) {

    const axiosInstance = useAxiosInstance()

    const [name, setArea] = useState('')  
    const [district, setDistrict] = useState('')
    
    useEffect(() => {
        async function fetchAndSetSingleDivision() {
          const { data } = await axiosInstance.get(AREA_API + targetID)
          setArea(data.name)
          setDistrict(data.district)
        }
        fetchAndSetSingleDivision()

      }, [targetID, axiosInstance])

    async function handleSubmit(e) {

        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('district', district)

        const response = await axiosInstance.patch(AREA_API + targetID, itemData)
        if (response) {
            triggerFetch()
            setShowUpdateForm(false)
        }
    }

    return (
        <div className='crate_form'>
            <Form onSubmit={handleSubmit}>
                <div>
                <ShortTextInput
                        label={`District`}
                        value={district}
                        placeholder={`Enter District`}
                        setState={setDistrict}
                    />
                    <ShortTextInput
                        label={`Area`}
                        value={name}
                        placeholder={`Enter Area`}
                        setState={setArea}
                    />
                </div>
                <FormSubmitButton text="Submit" />
            </Form>
        </div>
    )
}

export default UpdateArea